import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, mergeProps as _mergeProps, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "workflow-payload-node__key-cell" }
const _hoisted_2 = {
  key: 1,
  class: "workflow-payload-node__key-spacer"
}
const _hoisted_3 = { class: "workflow-payload-node__array-index" }
const _hoisted_4 = {
  key: 1,
  class: "workflow-payload-node__key-spacer"
}
const _hoisted_5 = { class: "workflow-payload-node__type-label" }
const _hoisted_6 = { key: 2 }
const _hoisted_7 = { class: "workflow-payload-node__actions" }
const _hoisted_8 = {
  key: 0,
  class: "workflow-payload-node__children"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_btn_toggle = _resolveComponent("v-btn-toggle")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_sheet = _resolveComponent("v-sheet")!
  const _component_WorkflowPayloadNode = _resolveComponent("WorkflowPayloadNode", true)!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["workflow-payload-node", { 'workflow-payload-node--root': _ctx.depth === 0, 'workflow-payload-node--nested': _ctx.depth > 0 }])
  }, [
    _createVNode(_component_v_sheet, {
      class: _normalizeClass(["workflow-payload-node__row", { 'workflow-payload-node__row--container': _ctx.isContainer }]),
      variant: "outlined",
      rounded: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_row, {
          align: "start",
          class: "ma-0",
          dense: ""
        }, {
          default: _withCtx(() => [
            (_ctx.parentType === 'object')
              ? (_openBlock(), _createBlock(_component_v_col, {
                  key: 0,
                  cols: "3",
                  class: "py-1"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_1, [
                      (_ctx.isContainer)
                        ? (_openBlock(), _createBlock(_component_v_btn, {
                            key: 0,
                            icon: _ctx.node.collapsed ? 'mdi-chevron-right' : 'mdi-chevron-down',
                            variant: "text",
                            density: "compact",
                            size: "small",
                            onClick: _ctx.toggleCollapsed
                          }, null, 8, ["icon", "onClick"]))
                        : (_openBlock(), _createElementBlock("span", _hoisted_2)),
                      _createVNode(_component_v_text_field, {
                        "model-value": _ctx.node.key,
                        "onUpdate:modelValue": _ctx.updateKey,
                        label: "Key",
                        density: "compact",
                        variant: "outlined",
                        rules: _ctx.keyRules,
                        "error-messages": _ctx.duplicateKeyErrors
                      }, null, 8, ["model-value", "onUpdate:modelValue", "rules", "error-messages"])
                    ])
                  ]),
                  _: 1
                }))
              : (_openBlock(), _createBlock(_component_v_col, {
                  key: 1,
                  cols: "3",
                  class: "py-1"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_3, [
                      (_ctx.isContainer)
                        ? (_openBlock(), _createBlock(_component_v_btn, {
                            key: 0,
                            icon: _ctx.node.collapsed ? 'mdi-chevron-right' : 'mdi-chevron-down',
                            variant: "text",
                            density: "compact",
                            size: "small",
                            onClick: _ctx.toggleCollapsed
                          }, null, 8, ["icon", "onClick"]))
                        : (_openBlock(), _createElementBlock("span", _hoisted_4)),
                      _createVNode(_component_v_icon, {
                        icon: "mdi-drag-horizontal",
                        size: "small"
                      }),
                      _createVNode(_component_v_chip, {
                        size: "x-small",
                        density: "compact",
                        variant: "tonal"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.index), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _cache[3] || (_cache[3] = _createElementVNode("div", { class: "workflow-payload-node__details-spacer" }, null, -1))
                  ]),
                  _: 1,
                  __: [3]
                })),
            _createVNode(_component_v_col, {
              cols: "2",
              class: "py-1"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_select, {
                  "model-value": _ctx.node.type,
                  "onUpdate:modelValue": _ctx.updateType,
                  items: _ctx.typeItems,
                  "item-title": "title",
                  "item-value": "value",
                  density: "compact",
                  variant: "outlined"
                }, {
                  selection: _withCtx(({ item }) => [
                    _createElementVNode("div", _hoisted_5, [
                      _createVNode(_component_v_icon, {
                        icon: item.raw.icon,
                        size: "small"
                      }, null, 8, ["icon"]),
                      _createElementVNode("span", null, _toDisplayString(item.raw.title), 1)
                    ])
                  ]),
                  item: _withCtx(({ props, item }) => [
                    _createVNode(_component_v_list_item, _mergeProps(props, {
                      "prepend-icon": item.raw.icon,
                      title: item.raw.title
                    }), null, 16, ["prepend-icon", "title"])
                  ]),
                  _: 1
                }, 8, ["model-value", "onUpdate:modelValue", "items"])
              ]),
              _: 1
            }),
            _createVNode(_component_v_col, { class: "py-1" }, {
              default: _withCtx(() => [
                (_ctx.node.type === 'string')
                  ? (_openBlock(), _createBlock(_component_v_text_field, {
                      key: 0,
                      "model-value": _ctx.node.value,
                      "onUpdate:modelValue": _ctx.updateValue,
                      density: "compact",
                      variant: "outlined"
                    }, null, 8, ["model-value", "onUpdate:modelValue"]))
                  : (_ctx.node.type === 'number')
                    ? (_openBlock(), _createBlock(_component_v_text_field, {
                        key: 1,
                        "model-value": _ctx.node.value,
                        "onUpdate:modelValue": _ctx.updateValue,
                        density: "compact",
                        variant: "outlined",
                        rules: _ctx.numberRules
                      }, null, 8, ["model-value", "onUpdate:modelValue", "rules"]))
                    : (_ctx.node.type === 'boolean')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                          _createVNode(_component_v_btn_toggle, {
                            "model-value": _ctx.node.value,
                            mandatory: "",
                            density: "compact",
                            variant: "outlined",
                            class: _normalizeClass({ 'workflow-payload-node__toggle--error': _ctx.valueErrors.length > 0 }),
                            "onUpdate:modelValue": _ctx.updateValue
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_btn, { value: true }, {
                                default: _withCtx(() => _cache[4] || (_cache[4] = [
                                  _createTextVNode("Yes")
                                ])),
                                _: 1,
                                __: [4]
                              }),
                              _createVNode(_component_v_btn, { value: false }, {
                                default: _withCtx(() => _cache[5] || (_cache[5] = [
                                  _createTextVNode("No")
                                ])),
                                _: 1,
                                __: [5]
                              })
                            ]),
                            _: 1
                          }, 8, ["model-value", "class", "onUpdate:modelValue"]),
                          _createElementVNode("div", {
                            class: _normalizeClass(["workflow-payload-node__messages", { 'workflow-payload-node__messages--error': _ctx.valueErrors.length > 0 }])
                          }, _toDisplayString(_ctx.valueErrors[0] || ''), 3)
                        ]))
                      : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_component_v_col, {
              cols: "auto",
              class: "py-1"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_7, [
                  (_ctx.isContainer)
                    ? (_openBlock(), _createBlock(_component_v_btn, {
                        key: 0,
                        icon: "mdi-plus",
                        variant: "text",
                        density: "compact",
                        size: "small",
                        onClick: _ctx.addChild
                      }, null, 8, ["onClick"]))
                    : _createCommentVNode("", true),
                  (_ctx.parentType === 'array')
                    ? (_openBlock(), _createBlock(_component_v_btn, {
                        key: 1,
                        icon: "mdi-arrow-up",
                        variant: "text",
                        density: "compact",
                        size: "small",
                        disabled: !_ctx.canMoveUp,
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('move-up')))
                      }, null, 8, ["disabled"]))
                    : _createCommentVNode("", true),
                  (_ctx.parentType === 'array')
                    ? (_openBlock(), _createBlock(_component_v_btn, {
                        key: 2,
                        icon: "mdi-arrow-down",
                        variant: "text",
                        density: "compact",
                        size: "small",
                        disabled: !_ctx.canMoveDown,
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('move-down')))
                      }, null, 8, ["disabled"]))
                    : _createCommentVNode("", true),
                  _createVNode(_component_v_btn, {
                    icon: "mdi-delete-outline",
                    variant: "text",
                    density: "compact",
                    size: "small",
                    color: "error",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('delete')))
                  })
                ]),
                _cache[6] || (_cache[6] = _createElementVNode("div", { class: "workflow-payload-node__details-spacer" }, null, -1))
              ]),
              _: 1,
              __: [6]
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["class"]),
    (_ctx.isContainer && !_ctx.node.collapsed)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.node.children, (child, childIndex) => {
            return (_openBlock(), _createBlock(_component_WorkflowPayloadNode, {
              key: child.id,
              node: child,
              "parent-type": _ctx.node.type === 'array' ? 'array' : 'object',
              index: childIndex,
              depth: _ctx.depth + 1,
              "validation-issues": _ctx.validationIssues,
              "can-move-up": childIndex > 0,
              "can-move-down": childIndex < _ctx.node.children.length - 1,
              onUpdate: _ctx.emitUpdate,
              onDelete: ($event: any) => (_ctx.deleteChild(childIndex)),
              onMoveUp: ($event: any) => (_ctx.moveChild(childIndex, childIndex - 1)),
              onMoveDown: ($event: any) => (_ctx.moveChild(childIndex, childIndex + 1))
            }, null, 8, ["node", "parent-type", "index", "depth", "validation-issues", "can-move-up", "can-move-down", "onUpdate", "onDelete", "onMoveUp", "onMoveDown"]))
          }), 128)),
          _createVNode(_component_v_btn, {
            class: "workflow-payload-node__add-child",
            "prepend-icon": "mdi-plus",
            variant: "outlined",
            density: "compact",
            onClick: _ctx.addChild
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.node.type === 'array' ? 'Add Item' : 'Add Field'), 1)
            ]),
            _: 1
          }, 8, ["onClick"])
        ]))
      : _createCommentVNode("", true)
  ], 2))
}